<template>
    <div class="big-iframe hidden">
        <iframe class="big-iframe" :src="url" frameborder="0"></iframe>
    </div>
</template>
<script>
    //import wordcloud from 'vue-wordcloud';
    export default {
        data() {
            return {
                url:''
            }
        },
        created (option){

        },
        mounted() {
            let that = this;
            let data = that.$route.query;
            let urlData = '';
            for(let i in data){
                urlData += i + '=' + data[i] + '&'
            }
            that.url = 'https://hot.gsdata.cn/newsDetails?api_secret=Ysdhk2SxgT7Xmsro2S&'+urlData
        },
        methods: {
            
        }
    }
</script>



// WEBPACK FOOTER //
// src/page/hotSpotEvents/eventDetail.vue